module.exports = __webpack_public_path__ + "static/img/2.273a820.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-view/2.jpg
// module id = HRBD
// module chunks = 1